exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/modules/_wks-ext.js
// module id = 116
// module chunks = 99